import navlid  from '../components/mycomponents/navlid.vue';

let obj = {};


obj.install = function(Vue){
    Vue.component('navlid',navlid)
}

export default obj